import { render, staticRenderFns } from "./EditableMovieRating.vue?vue&type=template&id=571bfd76&"
import script from "./EditableMovieRating.vue?vue&type=script&lang=js&"
export * from "./EditableMovieRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports